/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_Transcription_ServiceInputs */

const en_select_transcription_service = /** @type {(inputs: Select_Transcription_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the transcription service to use`)
};

const fr_select_transcription_service = /** @type {(inputs: Select_Transcription_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez le service de transcription à utiliser`)
};

const de_select_transcription_service = /** @type {(inputs: Select_Transcription_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie den zu verwendenden Transkriptionsdienst aus.`)
};

const it_select_transcription_service = /** @type {(inputs: Select_Transcription_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona il servizio di trascrizione da utilizzare`)
};

const ru_select_transcription_service = /** @type {(inputs: Select_Transcription_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите услугу транскрипции для использования.`)
};

const es_select_transcription_service = /** @type {(inputs: Select_Transcription_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione el servicio de transcripción que desea utilizar`)
};

const zh_cn2_select_transcription_service = /** @type {(inputs: Select_Transcription_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择要使用的转录服务。`)
};

const ja_select_transcription_service = /** @type {(inputs: Select_Transcription_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用する文字起こしサービスを選択してください`)
};

const hi_select_transcription_service = /** @type {(inputs: Select_Transcription_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपयोग करने के लिए ट्रांसक्रिप्शन सेवा का चयन करें`)
};

const pt_pt2_select_transcription_service = /** @type {(inputs: Select_Transcription_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o serviço de transcrição que deseja usar.`)
};

/**
* | output |
* | --- |
* | "Select the transcription service to use" |
*
* @param {Select_Transcription_ServiceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const select_transcription_service = /** @type {((inputs?: Select_Transcription_ServiceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_Transcription_ServiceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_select_transcription_service(inputs)
	if (locale === "de") return de_select_transcription_service(inputs)
	if (locale === "it") return it_select_transcription_service(inputs)
	if (locale === "ru") return ru_select_transcription_service(inputs)
	if (locale === "es") return es_select_transcription_service(inputs)
	if (locale === "zh-CN") return zh_cn2_select_transcription_service(inputs)
	if (locale === "ja") return ja_select_transcription_service(inputs)
	if (locale === "hi") return hi_select_transcription_service(inputs)
	if (locale === "pt-PT") return pt_pt2_select_transcription_service(inputs)
	return en_select_transcription_service(inputs)
});